/**
 * Types of items that can be in folders.
 * These values should align with the model RESOURCE_TYPE.
 */
export var FolderableType;
(function (FolderableType) {
    FolderableType["COMP_TABLES"] = "saved_comp_table";
    FolderableType["CUSTOM_PDF_REPORT"] = "custom_pdf_report";
    FolderableType["CUSTOM_SECURITY"] = "custom_security";
    FolderableType["EMAIL_REPORTS"] = "custom_email_report";
    FolderableType["FOLDER"] = "folder";
    FolderableType["FUND_CHART"] = "saved_fundamental_chart";
    FolderableType["FUND_SCREENER"] = "fund_screen";
    FolderableType["PORTFOLIO_OPTIMIZER"] = "portfolio_optimizer";
    FolderableType["MODEL_PORTFOLIO"] = "model_portfolio";
    FolderableType["SCATTER_PLOT"] = "scatter_plot";
    FolderableType["STOCK_SCREENER"] = "comp_screen";
    FolderableType["TALKING_POINTS"] = "user_talking_point";
    FolderableType["TIMESERIES"] = "saved_timeseries_table";
    FolderableType["WATCHLIST"] = "watchlist";
    FolderableType["HYPOTHETICAL"] = "hypothetical";
    FolderableType["TECH_CHART"] = "tech_chart";
})(FolderableType || (FolderableType = {}));
